/* eslint-disable prettier/prettier */ /* eslint-disable max-len */ 'use strict';
var totalPopulation = 0;
var population = document.getElementsByClassName('population');
for(var i = 0; i < population.length; i++){
    var populationValue = parseInt(population[i].textContent.split(',').join(''));
    totalPopulation += populationValue;
}
document.getElementsByClassName('total-population')[0].textContent = totalPopulation.toLocaleString();
document.getElementsByClassName('average-population')[0].textContent = (totalPopulation / population.length).toLocaleString();

//# sourceMappingURL=js_get_data_DOM.b3f25ce3.js.map
